import { TextButton } from '@wix/design-system'
import { ChevronLeftLarge } from '@wix/wix-ui-icons-common/lazy'
import React, { FC } from 'react'

import s from './WixMobileBackButton.scss'

interface WixMobileBackButtonProps {
  onBack: () => void
  label?: string
  dataHook?: string
}

export const WixMobileBackButton: FC<WixMobileBackButtonProps> = ({ onBack, dataHook }) => {
  return (
    <TextButton skin="dark" onClick={onBack} dataHook={dataHook} className={s.WixMobileBackButton}>
      <ChevronLeftLarge size="18px" className={s.WixMobileBackButton__icon} />
    </TextButton>
  )
}
